// extracted by mini-css-extract-plugin
module.exports = {"mainheading":"Forgot_mainheading__2FZu2","text":"Forgot_text__Qn-M2"};